import { render, staticRenderFns } from "./ListTableLabel.vue?vue&type=template&id=1843ac20&"
import script from "./ListTableLabel.vue?vue&type=script&lang=ts&"
export * from "./ListTableLabel.vue?vue&type=script&lang=ts&"
import style0 from "./ListTableLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
